"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerRoles = exports.MediaStatus = void 0;
var ServerRoles = exports.ServerRoles = /*#__PURE__*/function (ServerRoles) {
  ServerRoles["Cohost"] = "COHOST";
  ServerRoles["Moderator"] = "MODERATOR";
  ServerRoles["Presenter"] = "PRESENTER";
  return ServerRoles;
}({});
// values are inherited from locus so don't update these
var MediaStatus = exports.MediaStatus = /*#__PURE__*/function (MediaStatus) {
  MediaStatus["RECVONLY"] = "RECVONLY";
  MediaStatus["SENDONLY"] = "SENDONLY";
  MediaStatus["SENDRECV"] = "SENDRECV";
  MediaStatus["INACTIVE"] = "INACTIVE";
  MediaStatus["UNKNOWN"] = "UNKNOWN";
  return MediaStatus;
}({}); // participant has not added media in the meeting
//# sourceMappingURL=types.js.map
